// import getConfig from 'next/config';
import { getCookie, getTokenFromCookies } from '../../hooks/useCookie';
import { createCrossSellProspect } from '../../integration/cross-sell.api';
import {
  clearJourneyLocalStorage,
  clearLocalStorage,
  setLocalStorageWithPrefix,
} from '../../hooks/useLocalStorage';

// import eligibilityCheck from '../shared/eligibilityCheck';
// const { publicRuntimeConfig } = getConfig();

export const setJourneyPicker = async ({
  graphql,
  openJourneyPicker,
  openKeepNumberCheck,
  customerEligibility,
  journey,
  isStandaloneHandset,
  setShowSubscriptionModal,
  addNewMobileFromSubscriptionModal,
  crossSellHandsetJourney,
  coMobileSubscriptions,
  changeOfferJourney,
  setHidePortAccordian,
}) => {
  if (journey === 'cross_sell' || addNewMobileFromSubscriptionModal) {
    clearLocalStorage();
    if (getTokenFromCookies()) {
      if (
        customerEligibility?.crossSellEligibility?.serviceGroups?.filter(
          servicegrp => servicegrp.serviceGroup === 'MOBILE'
        )[0]?.eligible
      ) {
        // const accountId = customerEligibility?.subscriptions?.filter(
        //   subscription => subscription.serviceGroup === 'MOBILE'
        // )[0]?.accountId;
        if (isStandaloneHandset) {
          clearJourneyLocalStorage('ACQ');
          setLocalStorageWithPrefix('ION_EXISTING_CUSTOMER', true);
          crossSellHandsetJourney();
        } else {
          const accountId = getCookie('account_Id');
          const result = await createCrossSellProspect({
            graphql,
            accountId,
            offerType: 'POSTPAY',
          });
          openJourneyPicker?.disable();
          if (result && !isStandaloneHandset) {
            if (addNewMobileFromSubscriptionModal) setShowSubscriptionModal(false);
            openKeepNumberCheck.enable();
          }
        }
      }
    }
  } else if (journey === 'change_offer') {
    if (coMobileSubscriptions.length > 1) {
      setShowSubscriptionModal(true);
    } else {
      if (!isStandaloneHandset) {
        setHidePortAccordian(true);
      }
      changeOfferJourney(coMobileSubscriptions[0]?.id);
    }
  }
  openJourneyPicker?.disable();
};

export default setJourneyPicker;
